const API = 'research.users.notifications';
const VERSION = '1.0';

export const Notifications = {
  namespaced: true,

  state: {
    unreadNotificationCount: 0,
    projects: [],
    loadingProjects: false,
    loading: false,
  },

  getters: {
    unreadNotificationCount: (state) => state.unreadNotificationCount,
    projects: (state) => state.projects,
    loadingProjects: (state) => state.loadingProjects,
  },

  mutations: {
    setUnreadNotificationCount(state, count) {
      state.unreadNotificationCount = count;
    },

    setProjects(state, projects) {
      state.projects = projects;
    },

    setLoadingProjects(state, status) {
      state.loadingProjects = status;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async toggleRead(_, { notificationId, read, userUuid }) {
      try {
        await this._vm.$api('research.users.notifications.change_read_status', {
          version: VERSION,
          user: userUuid,
          notification: notificationId,
          mark_as: read,
        });
      } catch (error) {
        console.error(error);
      }
    },

    async triggerNotificationsCount({ commit }, { userId }) {
      try {
        const response = await this._vm.$api(API, {
          version: VERSION,
          user: userId,
          filter: {
            read: false,
          },
          perPage: 50,
          page: 1,
        });
        commit('setUnreadNotificationCount', response?.data?.total);
      } catch (error) {
        console.error(error);
      }
    },

    async getNotificationsProjects({ commit }, { userId, repositoryUuid = repositoryUuid }) {
      commit('setLoadingProjects', true);
      try {
        const response = await this._vm.$api('research.users.events_subscriptions_filters', {
          version: VERSION,
          user: userId,
          perPage: 50,
          page: 1,
          repository: repositoryUuid,
        });
        commit('setProjects', response?.data);
      } catch (error) {
        console.error(error);
      } finally {
        commit('setLoadingProjects', false);
      }
    },

    async markAllAsRead({ commit }, { userUuid, type, project }) {
      const payload = {};
      if (project) {
        payload.project_uuid = project;
      }

      if (type) {
        payload.type = type;
      }
      commit('setLoading', true);
      try {
        await this._vm.$api(
          'research.users.notifications.mark_all_as_read',
          {
            version: VERSION,
            user: userUuid,
          },
          payload
        );
      } catch (error) {
        console.error(error);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
